var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoShortCointimes = function SvgLogoShortCointimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Camada_2",
    viewBox: "0 0 102.42 132"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff5600}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.32 54.21C26.96 40.29 39.83 30.2 54.78 30.2c12.68 0 23.38 6.12 29.72 17.7l17.92-10.05C92.59 18.62 74.45 9.66 54.78 9.66 27.86 9.46 5.28 28.78 0 54.21zM54.78 101.44c-14.92 0-27.76-10.19-32.43-24.23H.03c5.34 25.54 27.88 44.93 54.74 44.55 19.67 0 37.81-8.74 47.64-28.19l-17.92-9.83c-6.34 11.58-17.05 17.7-29.72 17.7Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85 23h-23V0h16l7 11.5zM42.85 109h23v23h-16l-7-11.5z",
    className: "cls-1"
  }))));
};
export default SvgLogoShortCointimes;